export default __webpack_public_path__ + "static/media/stephanie.95265339.png";